const ErrorMessage = ({ content }: { content: string }) => (
  <div className="row">
    <div className="col-12">
      <div className="alert alert-danger">{content.toString()}</div>
    </div>
  </div>
);

export default ErrorMessage;
